import { Injectable } from '@angular/core';
import { PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { FinancialApiService } from '../financial-api.service';
import { EcomTransactionSearchDto } from './ecom-transaction-search.dto';
import { EcomTransactionDto } from './ecom-transaction.dto';

@Injectable({
  providedIn: 'root',
})
export class EcomTransactionService {
  constructor(private _apiService: FinancialApiService) {}

  search(searchParams: EcomTransactionSearchDto): Promise<PagedResultGeneric<EcomTransactionDto>> {
    let url = 'financial/v2/ecom/transactions';
    return this._apiService.post(url, searchParams);
  }

  MarkInvoicesAsSent(ids: number[]) {
    let url = 'financial/v2/ecom/transactions/mark-sent';
    return this._apiService.post(url, { InvoiceNums: ids });
  }

  exportToCsv(searchParams: EcomTransactionSearchDto): Promise<string> {
    let url = 'financial/v2/ecom/transactions/export';
    return this._apiService.post(url, searchParams, true);
  }
}
